import apiClient from "@/api/client";
import { saveBlobResponse } from "@/utils/download";

/** One row of the Protokoły POCK table — an issued protocol or a pending POCK request. */
export interface ProtocolExportRow {
  kind: "protocol" | "request";
  id: string;
}

// „Pobierz protokoły (.xlsx)" — lista filtruje i sortuje w przeglądarce, więc wiersze
// idą POST-em w bieżącym porządku, a plik pokrywa dokładnie odfiltrowane wiersze.
export const downloadProtocolsXlsx = async (rows: ProtocolExportRow[]) => {
  const resp = await apiClient.post("/protocols/export-xlsx/", { rows }, { responseType: "blob" });
  saveBlobResponse(resp, "Protokoly_POCK.xlsx");
};
